import { render, staticRenderFns } from "./TextAreaProvider.vue?vue&type=template&id=f828d712&scoped=true&"
import script from "./TextAreaProvider.vue?vue&type=script&lang=js&"
export * from "./TextAreaProvider.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaProvider.vue?vue&type=style&index=0&id=f828d712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f828d712",
  null
  
)

export default component.exports